var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('b-card-header',[_c('h2',{staticClass:"heading",attrs:{"id":_vm.value.Name.replace(/\s+/g, '_')}},[_vm._v(_vm._s(_vm.value.Name))]),_c('i',[_vm._v(_vm._s(_vm.value.School))])]),_c('center',[_c('b-img',{attrs:{"src":require("../assets/img/seniors/" + _vm.value.ImageName + ".jpg"),"fluid":""}})],1),_c('b-card-text')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }